export default "__VITE_ASSET__0LKkbdLe__"